import { ASSETS } from "@/lib/assets";

export const Logo = ({ size = 44, showText = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="modo-pro-logo">
    <img
      src={ASSETS.logo}
      alt="MODO PRO"
      width={size}
      height={size}
      className="rounded-full"
      style={{ width: size, height: size }}
    />
    {showText && (
      <span className="font-display font-bold tracking-widest text-sm uppercase text-white">
        Modo <span className="text-mp-orange">Pro</span>
      </span>
    )}
  </div>
);

export default Logo;
